export default __webpack_public_path__ + "static/media/theme-colored.6d1b89ac.jpg";